import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    gridColumns: {
        display: "grid",
        width: "100%",
        textAlign: "center",
        "& table": {
            borderCollapse: "collapse"
        },
        "& thead": {
            backgroundColor: theme.palette.grey.grey100,
            "& th": {
                color: theme.palette.grey.grey500,
                fontSize: "10px",
                fontWeight: 600,
                padding: "5px 10px",
                width: "200px"
            },
        },
        "& tbody": {
            "& th": {
                color: theme.palette.grey.grey700,
                fontSize: "14px",
                fontWeight: 600,
                padding: "5px 10px",
                borderBottom: "1px solid #ECECEC"
            },
            "& td": {
                color: theme.palette.grey.grey700,
                fontSize: "12px",
                fontWeight: 400,
                padding: "5px 10px",
                borderBottom: "1px solid #ECECEC"
            }
        }
    },
    subTitle: {
        color: theme.palette.black.dark,
        fontSize: "16px",
        fontWeight: 600,
        marginBottom: "10px"
    },
    noDataMessage: {
        color: theme.palette.black.dark,
        fontSize: "18px",
        fontWeight: 400,
        marginBottom: "10px",
        textAlign: "center"
    },
    iconeEvolution: {
        borderRadius: "200px",
        boxShadow: "0px 18px 40px 0px rgba(112, 144, 176, 0.12)",
        width: "15px",
        height: "15px",
        marginLeft: "5px",
        marginRight: "5px",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }
}))

export default useStyles;